import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  useMobileBreakpoint,
} from '@customink/pigment-react';
import type { MouseEventHandler } from 'react';
import { useMemo } from 'react';

export function DeleteConfirmationModal({
  designName,
  open,
  onClick,
  onClose,
}: {
  designName: string;
  open: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  onClose: MouseEventHandler<HTMLButtonElement>;
}) {
  const isMobile = useMobileBreakpoint();
  const buttonDirection = useMemo(
    () => (isMobile ? 'column-reverse' : 'row'),
    [isMobile],
  );
  return (
    <Dialog
      onClose={onClose}
      open={open}
      title={`Remove ${designName} from your cart?`}
    >
      <DialogContent>
        <Alert severity="error" sx={{ mt: '0.5rem' }}>
          This will remove all products with this design from your cart.
        </Alert>
      </DialogContent>
      <DialogActions direction={buttonDirection}>
        <Button onClick={onClose} variant="secondary">
          Cancel
        </Button>
        <Button onClick={onClick}>Yes, Remove Products</Button>
      </DialogActions>
    </Dialog>
  );
}
